import { type ComponentProps } from 'react';

import { useLocationSearchHelpers } from '../../../../hooks/useLocationSearchHelpers';
import { type Location, type LocationSearchService } from '../../../../machine';
import { LocationResultsCard } from '../../../LocationResults/subcomponents';

// ─────────────────────────────────────────────────────────────────────────────

export const LocationGroupCard = (props: Props) => {
  const { locationSearchActorRef, location, interactedLocationRestaurantSlug, isLoading, onPress } =
    props;

  const { restaurantSlug } = location;

  const { navigateToSelectedLocation, setFocusedLocationPin } = useLocationSearchHelpers({
    locationSearchActorRef,
  });

  // ─── Flags ───────────────────────────────────────────────────────────

  const isInteracted =
    interactedLocationRestaurantSlug !== undefined &&
    restaurantSlug !== undefined &&
    interactedLocationRestaurantSlug === restaurantSlug;

  // ─────────────────────────────────────────────────────────────────────

  return (
    <LocationResultsCard
      locationSearchActorRef={locationSearchActorRef}
      location={location}
      withDetailsModal
      isLoading={isInteracted || isLoading}
      isDisabled={isInteracted || isLoading}
      onPress={onPress ?? navigateToSelectedLocation}
      onFocus={setFocusedLocationPin}
    />
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  locationSearchActorRef: LocationSearchService; // prettier-ignore
  location: Location;
  interactedLocationRestaurantSlug?: string;
  isLoading?: boolean;

  /**
   * Optional press override. When provided (e.g. a telemetry-wrapped handler),
   * it is used instead of the actor-derived navigation action.
   */
  onPress?: ComponentProps<typeof LocationResultsCard>['onPress'];
};
